var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "popper",
    {
      key: _vm.rerenderKey,
      ref: "popper",
      class: _vm.currentClass,
      attrs: {
        "tag-name": _vm.tagName,
        options: _vm.allOptions,
        trigger: _vm.trigger,
        disabled: _vm.disabled,
        "delay-on-mouse-over": _vm.delayOnMouseOver,
        "delay-on-mouse-out": _vm.delayOnMouseOut,
        "append-to-body": _vm.appendToBody,
        "force-show": _vm.forceShow,
        "enter-active-class": _vm.enterActiveClass,
        "leave-active-class": _vm.leaveActiveClass,
        transition: _vm.transition,
        "stop-propagation": _vm.stopPropagation,
        "prevent-default": _vm.preventDefault,
        "visible-arrow": false
      },
      on: {
        created: function($event) {
          return _vm.$emit("created", $event)
        },
        show: function($event) {
          return _vm.onShow($event)
        },
        hide: function($event) {
          return _vm.onHide($event)
        },
        "document-click": function($event) {
          return _vm.$emit("document-click", $event)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "dropdown",
          class: _vm.dropdownClass,
          on: { click: _vm.dropdownClick }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "t-button",
        _vm._b(
          {
            ref: "button",
            attrs: {
              slot: "reference",
              disabled: _vm.disabled,
              variant: _vm.variant,
              active: _vm.shown,
              size: _vm.size,
              "tag-name": _vm.buttonTagName
            },
            on: {
              click: function($event) {
                return _vm.$emit("click", $event)
              },
              focus: function($event) {
                return _vm.$emit("focus", $event)
              },
              blur: function($event) {
                return _vm.$emit("blur", $event)
              }
            },
            slot: "reference"
          },
          "t-button",
          _vm.buttonProps,
          false
        ),
        [
          _vm._t(
            "button-content",
            [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")],
            { shown: _vm.shown }
          ),
          _vm._v(" "),
          _vm.visibleArrow
            ? _c(
                "svg",
                {
                  staticClass: "ml-1 h-5 w-5 fill-current text-gray-700",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z"
                    }
                  })
                ]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }